<i class="pi pi-exclamation-circle text-muted-color"></i>
<p class="font-semibold text-lg">Couldn't load your data</p>
<p class="text-muted-color mb-2">Check your connection, then try again.</p>
<homey-submit-button styleClass="min-w-[10rem]" submitButtonLabel="Try again" [submitFunction]="retry"/>
